module.exports = __webpack_public_path__ + "593bc397c78c3e15b3a32cd69767406e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/pineapple-head-s.png
// module id = 2934
// module chunks = 0